import React, {useEffect} from "react";
import useSWR from "swr";
import "swiper/css";
import { Autoplay, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { useMemo, useState } from "react";
import "./styles/DetallesTutor.css";
import { useLocation, useParams } from 'react-router-dom';
import CardUser from "./component/CardUser";
import './component/stylesComponent/Carrusel.css';
import CardProduct from "./component/CardProduct";
import { FaStar, FaStarHalfAlt, FaRegStar } from "react-icons/fa";
import Grid from '@mui/material/Grid2';
import { ComponerMensajeDialog } from '../View/Mensajes';
import $ from "jquery";

const getTutor = async (url) => {
    try{
        const res = await fetch(url, {
            method: "GET",
            headers: { "Content-Type": "application/json" },
        });

        if (!res.ok) throw new Error(`Error en la consulta ${url}`);

         const data = await res.json();

        if (Array.isArray(data.productos)) {
            data.productos = data.productos.filter(p => 
                p.Nombre != null &&
                p.Descripcion != null &&
                p.Tematica != null &&
                p.ImagenPortada != null &&
                p.FechaSubida != null
            );
        }
        
        return data;
    } catch(error){ console.error("Error al obtener el tutor " + error.message); }

};


const DetalleTutor = () => {
        
    useEffect(() => {
        $(".principal").hide().fadeIn(500);
    
        return () => {
          $(".principal").stop(true, true).show();
        };
      }, []);

    const { id } = useParams();
    const { state: fromState } = useLocation();

    //Estado para poder enviar mensajes a tutor
    const [compose, setCompose] = useState({ abierto: false, inicial: {} });

    const fallbackData = useMemo(() => ({
          tutor: fromState?.tutor,
          productos: [],
          ratingGlobal: 0,
          numResennas: 0,
          numVentas: 0,
          tutoresRelacionados: []
        }), [fromState]);

    let baseUrl;
    if(process.env.NODE_ENV === 'development') baseUrl = 'http://localhost:8080';
    else baseUrl='https://app-formacion.vercel.app';
    

    //Si se pasan los datos en el state se usa en fallback
    const { data: detalle, error, mutate: mutateUser } = useSWR(
        `${baseUrl}/api/users/tutor/${id}`, getTutor, {
          fallbackData,
          revalidateOnMount: true,
          revalidateOnFocus: false,
          revalidateOnReconnect: false,
          keepPreviousData: true,
          dedupingInterval: 30 * 60 * 1000,
        }
    );

    if (error) {
        return (
            <div>
                <p>Error al cargar detalle del tutor: {error.message}</p>;
            </div>
            )
      }
      if (!detalle?.tutor) {
        return (
            <div className="principal">
                <p style={{ textAlign: "center", fontStyle: "italic", marginTop: "2rem" }}>Cargando detalle del tutor...</p>;
            </div>
        )
      }

    const {
        tutor,
        productos,
        ratingGlobal,
        numResennas,
        numVentas,
        tutoresRelacionados,
    } = detalle;

  
                             
    return(
        <div className="principal">
            <div className='infoTutor'>
                <div className="infoPrincipal">

                    <div className="imagenValoracion">
                        <img style={{width: '270px'}} src={`data:image/png;base64,${tutor.ImagenPerfil}`} alt={`${tutor.Nombre } ${tutor.Apellidos}`} />
                        
                        <div className="valoracionContacto">
                            <div className="detallesItem">
                                <h4 className="label">Calificación del instructor: </h4>
                                <span className="value">
                                    {Array.from({length: 5}, (_, index) =>{
                                        const entero = Math.floor(ratingGlobal);
                                        const decimal = ratingGlobal - entero;

                                        if(index < entero) {
                                            return <FaStar key={index} style={{color: '#f67034'}} />;
                                        }
                                        else if (index === entero && decimal > 0.4){
                                            return <FaStarHalfAlt key={index} style={{color: '#f67034'}} />;
                                        }
                                        else{
                                            return <FaRegStar key={index} />;
                                        }
                                    })}
                                </span>
                            </div>
                            
                            <div className="detallesItem">
                                <h4 className="label">Usuario: </h4>
                                <span className="value"><strong>{tutor.Usuario}</strong></span>
                            </div>

                            {/*<div className="detallesItem">
                                <h5 className="label">Correo: </h5>
                                <span className="value"><strong>{tutor.Correo}</strong></span>
                            </div>*/}

                            <button onClick={() => {
                                setCompose({
                                    abierto: true,
                                    inicial: {
                                        Destinatarios: tutor.Usuario,
                                        Asunto: "",
                                        Contenido: "",
                                        Archivo: null,
                                        respuestaA: false,
                                        leerSoloDestinatarios: true
                                    },
                                });
                            }}
                            >
                                Contactar
                            </button>

                            <ComponerMensajeDialog
                              abierto={compose.abierto}
                              inicial={compose.inicial}
                              onClose={() => setCompose({ abierto: false, inicial: {} })}
                            />
                        </div>
                    </div>

                    <div className="infoDerecha">
                        <div className="descripcionNombre">
                            <h1 style={{color: 'var(--text-principal)'}}>{tutor.Nombre} {tutor.Apellidos}</h1>
                            <h4>Especializado en: <span><strong>{tutor.Tematicas?.join(", ")}</strong></span> </h4>                  
                        
                            <div className="detallesItem">
                                <h4 className="label">Fecha en la que se unió: </h4>
                                <span className="value">
                                    <strong>
                                        {new Date(tutor.FechaCreacion).toLocaleDateString("es-ES", {
                                            day: "2-digit",
                                            month: "2-digit",
                                            year: "numeric"
                                        })
                                        .replace(/\//g, "-")}
                                    </strong>
                                </span>
                            </div>

                            <div className="detallesItem">
                                <h4 className="label">Nº de contenido creado: </h4>
                                <span className="value">
                                    <strong>
                                        {productos.length}
                                    </strong>
                                </span>
                            </div>

                            <div className="detallesItem">
                                <h4 className="label">Nº reseñas recibidas: </h4>
                                <span className="value">
                                    <strong>
                                        {numResennas}
                                    </strong>
                                </span>
                            </div>

                            <div className="detallesItem">
                                <h4 className="label">Nº de ventas realizadas: </h4>
                                <span className="value">
                                    <strong>
                                        {numVentas}
                                    </strong>
                                </span>
                            </div>
                        </div> 
                    </div>
                </div>
            </div>
            
            <div className='mostrarContenido'>
                <h2>Cursos</h2>
                <div className="contenedorContenido">
                    <Grid container spacing={2} sx={{width: '100%', margin: 0}}>
                        {productos?.filter(prod => prod.tipo === "curso").map((prod) => (  
                                <Grid
                                    key={prod._id}
                                    sx={{
                                    flexBasis: {
                                        xs: '100%',      
                                        sm: '50%',       
                                        md: '33.33%',    
                                        lg: '24%'        
                                    },
                                    maxWidth: {
                                        xs: '100%',
                                        sm: '50%',
                                        md: '33.33%',
                                        lg: '24%'
                                    },
                                    display: 'flex'
                                    }}
                                >
                                    <CardProduct producto={prod} />
                                </Grid>
                        ))}
                    </Grid>
                </div>
            </div>

            <div className='mostrarContenido'>
                <h2>Clases</h2>
                <div className="contenedorContenido">
                    <Grid container spacing={2} sx={{width: '100%', margin: 0}}>
                        {productos?.filter(prod => prod.tipo === "clase").map((prod) => ( 
                                <Grid
                                    key={prod._id}
                                    sx={{
                                    flexBasis: {
                                        xs: '100%',      
                                        sm: '50%',       
                                        md: '33.33%',    
                                        lg: '24%'        
                                    },
                                    maxWidth: {
                                        xs: '100%',
                                        sm: '50%',
                                        md: '33.33%',
                                        lg: '24%'
                                    },
                                    display: 'flex'
                                    }}
                                >              
                                    <CardProduct producto={prod} />
                                </Grid>
                        ))}
                    </Grid>
                </div>
            </div>

            <div className='mostrarContenido'>
                <h2>Clases Particulares</h2>
                <div className="contenedorContenido">
                <Grid container spacing={2} sx={{width: '100%', margin: 0}}>
                    {productos?.filter(prod => prod.tipo === "claseParticular").map((prod) => ( 
                                <Grid
                                    key={prod._id}
                                    sx={{
                                    flexBasis: {
                                        xs: '100%',      
                                        sm: '50%',       
                                        md: '33.33%',    
                                        lg: '24%'        
                                    },
                                    maxWidth: {
                                        xs: '100%',
                                        sm: '50%',
                                        md: '33.33%',
                                        lg: '24%'
                                    },
                                    display: 'flex'
                                    }}
                                >   
                                    <CardProduct producto={prod} />
                                </Grid>
                        ))}
                </Grid>
                </div>
            </div>

            <div className='tutoresRelacionado'>
                <h2>Tutores relacionados</h2>
                    <div className="swiperContainer">
                        <Swiper 
                            modules={[Pagination, Autoplay]}
                            loop={tutoresRelacionados.length > 4}
                            autoplay={{
                                delay: 3000,
                                disableOnInteraction: false
                            }}
                            pagination={{
                                el: '.pagination',
                                clickable: true,
                            }}
                            slidesPerView={5}
                            spaceBetween={16}
                            breakpoints={{
                                "@0.00": {
                                    slidesPerView: 1,
                                    spaceBetween: 16,
                                },
                                "@0.50": {
                                    slidesPerView: 1.2,
                                    spaceBetween: 16,
                                },
                                "@1.00": {
                                    slidesPerView: 2,
                                    spaceBetween: 16,
                                },
                                "@1.25": {
                                    slidesPerView: 2.5,
                                    spaceBetween: 12,
                                },
                                "@1.50": {
                                    slidesPerView: 3,
                                    spaceBetween: 16,
                                },
                                "@1.75": {
                                    slidesPerView: 4,
                                    spaceBetween: 12,
                                },
                            }}
                        >
                            {tutoresRelacionados?.filter(tutR => tutR.Tipo === "Tutor").map((tutR) => {
                                return (
                                    <SwiperSlide key={tutR?._id}>
                                        <div style={{ height: "100%" }}>
                                            <CardUser tutor={tutR} />
                                        </div>
                                    </SwiperSlide>
                                );
                            })}
                            {tutoresRelacionados.length > 0 && <div className="pagination"></div>}  
                        </Swiper>
                    </div>
                </div>
            </div>
   );
};

export default DetalleTutor;
